
/**
 * 해시태그 기본 정보
 */
export type HashtagListResponsePageAllOfThreeContentItemBasicInfo = {
  tag: string;
};
